export function downloadBlob(blob: Blob, filename: string) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

export function getPropertyInitials(propertyName: string): string {
  return propertyName
    .trim()
    .split(' ')
    .filter((w: string) => w.length > 0)
    .map((w: string) => w[0].toUpperCase())
    .join('');
}
